var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchwhatever(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#D6512B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.142 15.916H28.38a.82.82 0 01-.82-.82v-1.395A2.704 2.704 0 0130.262 11a2.704 2.704 0 012.7 2.701v1.395a.82.82 0 01-.819.82zm-2.944-1.093h2.125v-1.122c0-.586-.477-1.063-1.062-1.063-.586 0-1.063.477-1.063 1.063v1.122z",
    fill: "#29376D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.592 24.283h-8.465a.82.82 0 01-.82-.82v-3.276l.002-.02v-.02l.273-5.055a.82.82 0 01.818-.78h7.721c.436 0 .796.341.819.776l.471 8.332c0 .546-.378.863-.819.863z",
    fill: "#FF645A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.592 24.283h-7.497v-9.97h7.026c.436 0 .796.34.819.775l.471 8.332c0 .546-.378.863-.819.863z",
    fill: "#FF3053"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.095 17.456v6.008a.82.82 0 01-.82.82h-8.488a.82.82 0 01-.81-.935l.383-6.008a.82.82 0 01.811-.704h8.105a.82.82 0 01.82.819z",
    fill: "#FABE2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.345 39a2.458 2.458 0 100-4.916 2.458 2.458 0 000 4.916z",
    fill: "#29376D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.62 39a2.458 2.458 0 100-4.916 2.458 2.458 0 000 4.916z",
    fill: "#47568C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.954 22.877a.82.82 0 01-.818.86h-8.081a.821.821 0 01-.819-.86L22.4 19.6a.82.82 0 01.818-.779h7.754a.82.82 0 01.818.779l.164 3.277z",
    fill: "#4793FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.954 22.877a.82.82 0 01-.818.86h-4.04v-4.916h3.876a.82.82 0 01.818.779l.164 3.277z",
    fill: "#4756FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.407 23.124l-1.431 4.952a3.549 3.549 0 01-3.464 2.732H19.54c-.4-1.631-1.518-5.508-2.33-8.71h18.404a.82.82 0 01.793 1.026z",
    fill: "#DFE7F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.407 23.124l-1.431 4.952a3.549 3.549 0 01-3.464 2.732h-4.417v-8.71h8.519a.82.82 0 01.793 1.026z",
    fill: "#B6C0D1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.62 37.362a.82.82 0 100-1.64.82.82 0 000 1.64z",
    fill: "#F0F7FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.345 37.362a.82.82 0 100-1.64.82.82 0 000 1.64z",
    fill: "#DFE7F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.248 33.265a.82.82 0 01-.82.82h-11.74a3.16 3.16 0 01-3.085-2.441c-.282-.993-.177-.623-3.346-13.284a.813.813 0 00-.788-.614h-2.65a.82.82 0 010-1.639h2.65c1.123 0 2.1.76 2.377 1.849l.911 3.596a2004.17 2004.17 0 012.329 9.255c.048.195.086.351.111.46.165.694.778 1.179 1.492 1.179h11.74a.82.82 0 01.82.82z",
    fill: "#47568C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.248 33.264a.82.82 0 01-.82.82h-6.333v-1.639h6.334a.82.82 0 01.82.82z",
    fill: "#29376D"
  })));
}
export default "/_next/static/media/launchwhatever.723b2a28753590d068e52f0325b260a0.svg";
export { SvgLaunchwhatever as ReactComponent };